/*
 * @Author: zyy
 * @Date: 2022-03-28 10:51:12
 * @LastEditors: zyy
 * @LastEditTime: 2022-04-13 18:12:08
 * @Description: default
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const router = new VueRouter({});

router.beforeEach((to, from, next) => {
  let path = ['/entrance', '/menu_manage', '/blank', '/mistake', '/no_auth'];
  if (to.path === '/') {
    next('/blank');
  } else if (path.indexOf(to.path) > -1) {
    next();
  } else {
    if (store.state.userInfo) {
      next();
    } else {
      store.commit('setRedirectUrl', to.fullPath);
      next('/blank');
    }
  }
});

export default router;
